import clsx from 'clsx';
import type { PropsWithChildren, ReactNode } from 'react';

import { section } from './settings-primitives.css';
import { wrapper } from './share.css';

interface SettingWrapperProps {
  id?: string;
  sectionId?: string;
  className?: string;
  titleClassName?: string;
  title?: ReactNode;
  disabled?: boolean;
  testId?: string;
}

export const SettingWrapper = ({
  id,
  sectionId,
  className,
  titleClassName,
  title,
  children,
  disabled,
  testId,
}: PropsWithChildren<SettingWrapperProps>) => {
  return (
    <div
      id={id}
      data-setting-section={sectionId}
      className={clsx(className ?? section, wrapper)}
      data-testid={testId}
      aria-disabled={disabled}
    >
      {title ? <div className={titleClassName ?? 'title'}>{title}</div> : null}
      {children}
    </div>
  );
};
